import { slugs } from '@/constants/slugs'

export interface EarlyBirdValuesType {
  video?: string
  image?: string
  bgColor: string
  large: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
    image?: string
  }
  medium: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  small: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  experimentValues?: {
    video?: string
    image?: string
    bgColor?: string
  }
}

export const EarlyBirdValues: Record<string, EarlyBirdValuesType> = {
  [slugs.theLastRodeo]: {
    video: 'https://images.angelstudios.com/video/upload/c_scale,h_453/v1744234819/tkok-popcorn-vid-01_vxdwcr.mp4',
    bgColor: 'bg-[#EAE0D9]',
    large: {
      classNames: 'z-[9] right-0',
      gradientWidth: 'w-[250px] lg:w-[215px]',
      gradientHeight: 'lg:!h-[140px] !h-[160px]',
      image: 'https://images.angelstudios.com/image/upload/v1743945341/the-last-rodeo/neal-cropped2.jpg',
    },
    medium: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[254px]',
      gradientHeight: '!h-[160px]',
    },
    small: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[270px]',
      gradientHeight: '!h-[160px]',
    },
    image: 'https://images.angelstudios.com/image/upload/v1743945341/the-last-rodeo/neal-cropped2.webp',
    experimentValues: {
      video: 'https://images.angelstudios.com/video/upload/c_scale,h_453/v1744234819/tkok-popcorn-vid-01_vxdwcr.mp4',
      bgColor: '#EAE0D9',
    },
  },
}
